// extracted by mini-css-extract-plugin
export default {"report-container":"styles_report-container__zXwZb","report-type-download":"styles_report-type-download__NOonZ","report-type":"styles_report-type__ySmQs"};